import React, { useCallback } from 'react';
import useEvent from '@react-hook/event';
import { isClientSide } from '@moda/portal-stanchions';
import { Stack, Text } from '@moda/om';
import { ProductDetailsFragment } from '../../generated/types';
import { tc } from '../../lib/trackingContext';
import './EditorsNote.scss';

interface Props {
  variant: ProductDetailsFragment;
}

export const EditorsNote: React.FC<Props> = ({ variant: { description } }) => {
  const element = isClientSide() ? document.querySelector<HTMLElement>('.EditorsNote a') : null;

  const trackClick = useCallback(() => {
    tc.track("Editor's Note Link Clicked", {
      addToTrackingEvent: { label: element?.getAttribute('href') || '' }
    });
  }, [element]);

  useEvent(element, 'mousedown', trackClick);

  if (!description || description == '<p></p>\n') return null;
  return (
    <Stack className="EditorsNote" space={3}>
      <Text treatment="bold1">EDITOR'S NOTE</Text>
      <Text dangerouslySetInnerHTML={{ __html: description || '' }} />
    </Stack>
  );
};
